/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  H5pContent,
  H5pContentRequestInput,
  ListH5pContentsParams,
  PaginatedH5pContents,
  SchemaValidationErrorResponse,
  UpdateH5pContentInput,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create H5P Content
 */
export const createH5pContent = (
    h5pContentRequestInput: MaybeRefOrGetter<H5pContentRequestInput>,
 signal?: AbortSignal
) => {
      h5pContentRequestInput = toValue(h5pContentRequestInput);

      return axiosClient<H5pContent>(
      {url: `/h5p_contents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: h5pContentRequestInput, signal
    },
      );
    }




export const getCreateH5pContentMutationKey = () => ['createH5pContent'] as const;

export const getCreateH5pContentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createH5pContent>>, TError,CreateH5pContentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createH5pContent>>, TError,CreateH5pContentMutationVariables, TContext> => {

const mutationKey = getCreateH5pContentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createH5pContent>>, CreateH5pContentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createH5pContent(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateH5pContentMutationResult = NonNullable<Awaited<ReturnType<typeof createH5pContent>>>
    export type CreateH5pContentMutationBody = H5pContentRequestInput
    export type CreateH5pContentMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateH5pContentMutationVariables = {data: H5pContentRequestInput}

    /**
 * @summary Create H5P Content
 */
export const useCreateH5pContent = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createH5pContent>>, TError,CreateH5pContentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createH5pContent>>,
        TError,
        CreateH5pContentMutationVariables,
        TContext
      > => {
      return useMutation(getCreateH5pContentMutationOptions(options), queryClient);
    }
    /**
 * @summary List of H5P Contents
 */
export const listH5pContents = (
    params?: MaybeRefOrGetter<ListH5pContentsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedH5pContents>(
      {url: `/h5p_contents`, method: 'GET',
        params, signal
    },
      );
    }




export const getListH5pContentsQueryKey = (params?: MaybeRefOrGetter<ListH5pContentsParams>,) => {
    return [
    'h5p_contents', ...(params ? [params] : [])
    ] as const;
    }


export const getListH5pContentsQueryOptions = <TData = Awaited<ReturnType<typeof listH5pContents>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListH5pContentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listH5pContents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListH5pContentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listH5pContents>>> = ({ signal }) => listH5pContents(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listH5pContents>>, TError, TData>
}

export type ListH5pContentsQueryResult = NonNullable<Awaited<ReturnType<typeof listH5pContents>>>
export type ListH5pContentsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of H5P Contents
 */

export function useListH5pContents<TData = Awaited<ReturnType<typeof listH5pContents>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListH5pContentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listH5pContents>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListH5pContentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete H5P Content
 */
export const deleteH5pContent = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/h5p_contents/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteH5pContentMutationKey = () => ['deleteH5pContent'] as const;

export const getDeleteH5pContentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteH5pContent>>, TError,DeleteH5pContentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteH5pContent>>, TError,DeleteH5pContentMutationVariables, TContext> => {

const mutationKey = getDeleteH5pContentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteH5pContent>>, DeleteH5pContentMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteH5pContent(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteH5pContentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteH5pContent>>>

    export type DeleteH5pContentMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteH5pContentMutationVariables = {id: string}

    /**
 * @summary Delete H5P Content
 */
export const useDeleteH5pContent = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteH5pContent>>, TError,DeleteH5pContentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteH5pContent>>,
        TError,
        DeleteH5pContentMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteH5pContentMutationOptions(options), queryClient);
    }
    /**
 * @summary Show H5P Content
 */
export const showH5pContent = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<H5pContent>(
      {url: `/h5p_contents/${id}`, method: 'GET', signal
    },
      );
    }




export const getShowH5pContentQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'h5p_contents',id
    ] as const;
    }


export const getShowH5pContentQueryOptions = <TData = Awaited<ReturnType<typeof showH5pContent>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showH5pContent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowH5pContentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showH5pContent>>> = ({ signal }) => showH5pContent(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof showH5pContent>>, TError, TData>
}

export type ShowH5pContentQueryResult = NonNullable<Awaited<ReturnType<typeof showH5pContent>>>
export type ShowH5pContentQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Show H5P Content
 */

export function useShowH5pContent<TData = Awaited<ReturnType<typeof showH5pContent>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showH5pContent>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShowH5pContentQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update H5P Content
 */
export const updateH5pContent = (
    id: MaybeRefOrGetter<string>,
    updateH5pContentInput?: MaybeRefOrGetter<UpdateH5pContentInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
updateH5pContentInput = toValue(updateH5pContentInput);

      return axiosClient<H5pContent>(
      {url: `/h5p_contents/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateH5pContentInput, signal
    },
      );
    }




export const getUpdateH5pContentMutationKey = () => ['updateH5pContent'] as const;

export const getUpdateH5pContentMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateH5pContent>>, TError,UpdateH5pContentMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateH5pContent>>, TError,UpdateH5pContentMutationVariables, TContext> => {

const mutationKey = getUpdateH5pContentMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateH5pContent>>, UpdateH5pContentMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateH5pContent(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateH5pContentMutationResult = NonNullable<Awaited<ReturnType<typeof updateH5pContent>>>
    export type UpdateH5pContentMutationBody = UpdateH5pContentInput | undefined
    export type UpdateH5pContentMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateH5pContentMutationVariables = {id: string;data?: UpdateH5pContentInput}

    /**
 * @summary Update H5P Content
 */
export const useUpdateH5pContent = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateH5pContent>>, TError,UpdateH5pContentMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateH5pContent>>,
        TError,
        UpdateH5pContentMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateH5pContentMutationOptions(options), queryClient);
    }
